import { ref, Ref } from 'vue'
import { Subscriber } from '@/model/data-object/Subscriber'

const subscribers: Ref<Array<Subscriber>> = ref([])

export default function useSubscribersMap() {
  const addSubscribers = (newSubs: Array<Subscriber>) => {
    newSubs.forEach((subscriber: Subscriber) => {
      subscriber.lastNotifiedAt = new Date(subscriber.lastNotifiedAt)
      subscribers.value.push(subscriber)
    })
  }

  const getLastSubscriber = (): Subscriber | null => {
    if (subscribers.value.length > 0) {
      return subscribers.value[subscribers.value.length - 1]
    }

    return null
  }

  const removeSubscriber = (postId: number): void => {
    subscribers.value = subscribers.value.filter(
      (subscriber: Subscriber) => subscriber.id !== postId
    )
  }

  const clearMap = () => {
    subscribers.value.length = 0
  }

  return {
    subscribers,
    addSubscribers,
    getLastSubscriber,
    clearMap,
    removeSubscriber,
  }
}
